import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
const pageVariants = {
  initial: { opacity: 0, scale: 0.96, filter: "blur(6px)" },
  animate: { opacity: 1, scale: 1, filter: "blur(0px)" },
  exit: { opacity: 0, x: -60, filter: "blur(4px)" },
};
const factors = [
  {
    icon: "📐",
    title: "Wall Size",
    desc: "Larger walls require more materials, labor, and execution time, which directly impacts the overall project cost.",
  },
  {
    icon: "🎨",
    title: "Design Complexity",
    desc: "Simple graphic designs generally require less effort than highly detailed artistic murals, 3D wall art, or custom illustrations.",
  },
  {
    icon: "🖼️",
    title: "Type of Mural",
    desc: "Different mural styles have different pricing structures — interior murals, exterior murals, office murals, school wall paintings, restaurant wall art, fiberglass murals, and GRC sculptural murals all vary in scope.",
  },
  {
    icon: "🧱",
    title: "Surface Preparation",
    desc: "Walls that require repairs, priming, or special treatment may increase overall project costs.",
  },
  {
    icon: "📍",
    title: "Location of the Project",
    desc: "Projects in Chennai, surrounding areas, or other cities may involve different logistics and installation requirements.",
  },
];
function Blog4() {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.7, ease: "easeInOut" }}
      style={{ background: "var(--canvas)", minHeight: "100vh" }}
    >
      <div
        style={{
          background:
            "linear-gradient(150deg,#0a1828 0%,#1a0a2e 55%,#1a0808 100%)",
          padding: "100px 6% 70px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: 300,
            height: 300,
            borderRadius: "60% 40% 55% 45% / 50% 60% 40% 55%",
            background: "var(--coral)",
            opacity: 0.1,
            top: -60,
            left: -60,
          }}
        />
        <div
          style={{
            position: "absolute",
            width: 200,
            height: 200,
            borderRadius: "50%",
            background: "var(--gold)",
            opacity: 0.07,
            bottom: -20,
            right: 100,
          }}
        />
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          style={{
            color: "#c9982a",
            fontWeight: 700,
            fontSize: "0.78rem",
            letterSpacing: "3px",
            textTransform: "uppercase",
            marginBottom: "16px",
          }}
        >
          PRICING GUIDE · CHENNAI · 2026
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35, duration: 0.8 }}
          style={{
            fontFamily: "var(--font-serif)",
            fontStyle: "italic",
            fontWeight: 900,
            fontSize: "clamp(1.8rem,5vw,3.2rem)",
            color: "#fff",
            lineHeight: 1.2,
            maxWidth: 720,
            margin: "0 auto 24px",
          }}
        >
          Wall Mural Cost in Chennai: Complete Pricing Guide (2026)
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          style={{
            color: "rgba(255,255,255,0.55)",
            fontSize: "0.88rem",
            letterSpacing: "1px",
          }}
        >
          4 min read
        </motion.p>
      </div>
      <div
        style={{
          maxWidth: 780,
          margin: "0 auto",
          padding: "64px 6% 100px",
        }}
      >
        <p
          style={{
            fontSize: "1.1rem",
            lineHeight: 1.85,
            color: "#333",
            marginBottom: "32px",
            borderLeft: "4px solid #f26540",
            paddingLeft: "20px",
            fontStyle: "italic",
          }}
        >
          If you're planning to enhance your home, office, school, restaurant,
          or commercial property, understanding the wall mural cost in Chennai
          is one of the first steps. Every project is unique — here's what
          shapes the price.
        </p>
        <h2
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.7rem",
            fontWeight: 700,
            color: "#1a0a2e",
            margin: "48px 0 16px",
          }}
        >
          How Much Does a Wall Mural Cost in Chennai?
        </h2>
        <p style={{ lineHeight: 1.85, color: "#444", marginBottom: "40px" }}>
          The cost of custom wall murals in Chennai typically depends on the
          scope of the project rather than a fixed rate. Every mural is unique,
          which is why professional mural artists usually provide customized
          quotations after evaluating the space and design requirements.
        </p>
        <h2
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.7rem",
            fontWeight: 700,
            color: "#1a0a2e",
            margin: "48px 0 28px",
          }}
        >
          Factors That Affect Wall Mural Pricing
        </h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {factors.map((f, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07 }}
              style={{
                display: "flex",
                gap: "20px",
                padding: "24px",
                background: "#fff",
                borderRadius: "10px",
                boxShadow: "0 2px 16px rgba(0,0,0,0.05)",
                border: "1px solid #f0ece4",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  background: "rgba(242,101,64,0.1)",
                  border: "1.5px solid rgba(242,101,64,0.3)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.4rem",
                  flexShrink: 0,
                }}
              >
                {f.icon}
              </div>
              <div>
                <strong
                  style={{
                    display: "block",
                    fontSize: "1rem",
                    fontWeight: 700,
                    color: "#1a0a2e",
                    marginBottom: "6px",
                  }}
                >
                  {f.title}
                </strong>
                <p style={{ lineHeight: 1.75, color: "#555", margin: 0 }}>
                  {f.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
        <h2
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.7rem",
            fontWeight: 700,
            color: "#1a0a2e",
            margin: "56px 0 16px",
          }}
        >
          Why Invest in Professional Mural Services?
        </h2>
        <p style={{ lineHeight: 1.85, color: "#444", marginBottom: "20px" }}>
          Hiring experienced mural artists in Chennai ensures high-quality
          artwork, durable materials, and professional execution. A custom mural
          not only enhances aesthetics but also improves branding, customer
          experience, and property value.
        </p>
        <p style={{ lineHeight: 1.85, color: "#444", marginBottom: "44px" }}>
          For businesses, commercial wall murals in Chennai can create memorable
          customer experiences and strengthen brand identity. Schools can use
          educational murals to inspire learning, while offices can use custom
          wall art to improve employee engagement.
        </p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{
            background: "linear-gradient(135deg,#1a0a2e,#2a0a1e)",
            borderRadius: "14px",
            padding: "40px",
            textAlign: "center",
            marginBottom: "44px",
          }}
        >
          <p
            style={{
              color: "#c9982a",
              fontWeight: 700,
              fontSize: "0.78rem",
              letterSpacing: "3px",
              textTransform: "uppercase",
              marginBottom: "12px",
            }}
          >
            GET A CUSTOM QUOTE
          </p>
          <h3
            style={{
              fontFamily: "var(--font-serif)",
              color: "#fff",
              fontSize: "1.6rem",
              fontWeight: 700,
              marginBottom: "14px",
            }}
          >
            Get a Custom Mural Quote in Chennai
          </h3>
          <p
            style={{
              color: "rgba(255,255,255,0.65)",
              lineHeight: 1.75,
              maxWidth: 500,
              margin: "0 auto 28px",
            }}
          >
            Since every project is unique, the best way to determine the exact
            wall painting cost is through a site assessment and consultation.
            Whether you need office murals, restaurant wall art, school wall
            painting, or custom mural design services, we'll help you find the
            right solution for your budget.
          </p>
          <Link to="/contact" style={{ textDecoration: "none" }}>
            <motion.button
              whileHover={{ background: "#b8882a" }}
              style={{
                padding: "14px 32px",
                background: "#c9982a",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                fontWeight: 700,
                fontSize: "0.9rem",
                letterSpacing: "1px",
                cursor: "pointer",
                textTransform: "uppercase",
                transition: "background 0.3s",
              }}
            >
              Request a Free Site Assessment
            </motion.button>
          </Link>
        </motion.div>
      </div>
    </motion.div>
  );
}
export default Blog4;
